export default __webpack_public_path__ + "static/media/beatRoot.66ecf85a.webp";